import { weave } from '../../../components/utils/arrayUtils'

export const imagesLandscape = [
  {
    // 1
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry/1/large-a7bbf5c81ee8779d16e1af6f9743d9ef.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/1/medium-5f64653935fdb060c7d5856149352e63.webp',
  },
  {
    // 2
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry/2/large-6d050ab12f6fda5b098ef1649937ace8.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/2/medium-440c14a711376ad9092b8d25c8943c6c.webp',
  },
  {
    // 3
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry/3/large-84d65cf9e2186733534f01d18cd91159.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/3/medium-5ebe2c19dd4fd65c2a57ab2d5d24b689.webp',
  },
  {
    // 4
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry/4/large-f88fb24e1c1adbde94e32485664acf78.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/4/medium-c9698062316d6c40861dbc13cd58c73c.webp',
  },
  {
    // 5
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry/5/large-55f9b7b0e9f9d8ae722f887c8ac243eb.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/5/medium-f30707c1746ecc1d264cde7d27fef655.webp',
  },
  {
    // 6
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry/6/large-71f170ac89b44789924332f29df40061.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/6/medium-52df5b30871edfeecf069501bd625998.webp',
  },
]

export const imagesPortrait = [
  {
    // 7
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry/7/large-bb9806ad324015d5df11e90862b0e8fd.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/7/medium-88e1bf03fd2e1b138fa638635d174139.webp',
  },

  {
    // 8
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry/8/large-f26acc4099800be8b88184995d29c6cd.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/8/medium-ca5cc8426fb052a97c4d3e7e83b8b477.webp',
  },

  {
    // 9
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry/9/large-060df928d384f17681e57bd40bba6f36.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/9/medium_03-11-2021.webp',
  },

  {
    // 10
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry/10/large-03352efa4abadf375d272d1e430cca4f.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/10/medium-8e57f5f1bd2fc45507e7ba4cfc6a7dfe.webp',
  },

  {
    // 11
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry/11/large-2cf89580cd1bfef06e3c1703acb7c8d3.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/11/medium-40e73faf77ab20449269a4094607bfe9.webp',
  },

  {
    // 12
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry/12/large-7839005c6dc8a157575429cab41d7cfc.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry/12/medium-b1f8653c1fc89ca34cc0b7a795b74a8d.webp',
  },
]

export const images = weave(imagesLandscape, imagesPortrait)

export const imagesLandscapeNZ = [
  {
    // 3
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry_nz/3/large-0f5bbf9e89d7923f41a87c16ae082738.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/3/medium-39b38dd6b42b799d23dd448f2e7eae26.webp',
  },

  {
    // 5
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry_nz/5/large-887d5f7311269ce12c4e2d3e9df026f4.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/5/medium-908817b4e1959c6f20f6aa774404030e.webp',
  },

  {
    // 2
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry_nz/2/large-7c58585d195fbd1df6681e556555adec.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/2/medium-c32998b04f8ea528c4efb3b3d8d408c2.webp',
  },

  {
    // 4
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry_nz/4/large-8321656e169bd0a9f412f22810bc6259.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/4/medium-6e76a04599d99af86af7a0ab943803a1.webp',
  },

  {
    // 1
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry_nz/1/large-c13f2d9556ca1db5f3730b17a829d35c.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/1/medium-4df8233a4f5173fce025269dbce58d3c.webp',
  },

  {
    // 6
    // landscape
    large:
      'https://assets.riparide.com/home/header/masonry_nz/6/large-66717b023c430f95448a56c773bdb757.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/6/medium-0942dcac8fa15fb0cf168f2c4cc7080b.webp',
  },
]

export const imagesPortraitNZ = [
  {
    // 8
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry_nz/8/w800-ea14d033ccbb98f9409aae9e27ae4d94.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/8/w400-cad4ef803886b0ed70855c844aa06527.webp',
  },

  {
    // 7
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry_nz/7/large-41caa8c28a2684c32cf1738ed3f9ba7a.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/7/medium-63f1905672576ee1c50bc9a73f5ec48f.webp',
  },

  {
    // 9
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry_nz/9/large-4d41bbb71533f63dfdad743fb6b9c00c.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/9/medium-c13f0942d76682d3e8f91b741dbbbbea.webp',
  },

  {
    // 10
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry_nz/10/w800-96b39cbd716c75c0c8df6f86185e85f6.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/10/w400-01dac749bbb731f2980f239ed3998893.webp',
  },

  {
    // 11
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry_nz/11/w800-af820bb818271ce047c37263b3220860.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/11/w400-a6d178648a31d180d5be73c2444787b9.webp',
  },

  {
    // 12
    // portrait
    large:
      'https://assets.riparide.com/home/header/masonry_nz/12/w800-d55b294438bde8d17530cc501842f061.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_nz/12/w400-66d26e2513c2af69bc5d3ba78fa12559.webp',
  },
]

export const imagesNZ = weave(imagesLandscapeNZ, imagesPortraitNZ)

const imagesLandscapeWA = [
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_1_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_1_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_2_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_2_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_3_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_3_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_4_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_4_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_5_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_5_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_6_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/landscape_6_medium_2022-04-19.webp',
  },
]

const imagesPortraitWA = [
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_1_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_1_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_2_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_2_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_3_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_3_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_4_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_4_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_5_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_5_medium_2022-04-19.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_6_large_2022-04-19.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_wa/portrait_6_medium_2022-04-19.webp',
  },
]

export const imagesWA = weave(imagesLandscapeWA, imagesPortraitWA)

const imagesLandscapeOR = [
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/landscape_1_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/landscape_1_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/landscape_5_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/landscape_5_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/landscape_3_large_2022-06-29.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/landscape_3_medium_2022-06-29.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/landscape_2_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/landscape_2_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/landscape_4_large_2022-06-29.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/landscape_4_medium_2022-06-29.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/landscape_6_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/landscape_6_medium_2022-06-28.webp',
  },
]

const imagesPortraitOR = [
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/portrait_1_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/portrait_1_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/portrait_2_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/portrait_2_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/portrait_6_large_2022-06-29.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/portrait_6_medium_2022-06-29.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/portrait_4_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/portrait_4_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/portrait_6_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/portrait_6_medium_2022-06-28.webp',
  },
  {
    large:
      'https://assets.riparide.com/home/header/masonry_or/portrait_3_large_2022-06-28.webp',
    medium:
      'https://assets.riparide.com/home/header/masonry_or/portrait_3_medium_2022-06-28.webp',
  },
]

export const imagesOR = weave(imagesLandscapeOR, imagesPortraitOR)
